import type { Me } from '@smarton-pbx/shared';
import { api, photoUrl } from '../api';
import { t } from '../i18n';
import { Headphones, Languages } from 'lucide-react';
import { AccountPage } from '../components/AccountPage';
import { LanguageSwitch } from '../components/LanguageSwitch';
import { CallRulesCard } from './CallRules';
import { MyNotifications } from './NotificationPreferences';
import { PhoneAppCard } from './PhoneAppCard';
import { PermissionRows } from './PhoneSetup';
import { PhotoControls } from './PhotoControls';
import { roleNames } from './People';

/** onChanged: reloads the person (their photo shows in the sidebar too). */
export function Account({ me, onChanged }: { me: Me; onChanged: () => void }) {
  return (
    <AccountPage
      name={me.name}
      email={me.email}
      details={
        me.region
          ? t('{role} in {region} · extension {extension}', { role: roleNames[me.role], region: me.region.name, extension: me.extension })
          : t('{role} · extension {extension}', { role: roleNames[me.role], extension: me.extension })
      }
      mfaEnabled={me.mfaEnabled}
      changePassword={api.changePassword}
      photo={photoUrl(me.id, me.photoVersion)}
      photoControls={<PhotoControls version={me.photoVersion} onChange={onChanged} />}
    >
      <div className="card">
        <div className="card-header">
          <div className="row" style={{ gap: '0.6rem' }}>
            <Headphones size={18} className="subtle" aria-hidden />
            <h2>{t('Phone in this browser')}</h2>
          </div>
        </div>
        <div className="card-body">
          <PermissionRows />
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <div className="row" style={{ gap: '0.6rem' }}>
            <Languages size={18} className="subtle" aria-hidden />
            <h2>{t('Language')}</h2>
          </div>
        </div>
        <div className="card-body stack" style={{ gap: '0.6rem' }}>
          <p className="subtle">{t('The language you see this app in, in every browser you sign in to.')}</p>
          <div>
            <LanguageSwitch save={api.setLanguage} />
          </div>
        </div>
      </div>
      <CallRulesCard />
      <PhoneAppCard />
      <MyNotifications />
    </AccountPage>
  );
}
